import React from 'react';
import ThemeableComponent from 'nucleus-widgets/lib/ThemeableComponent';
import { resolve } from '@cvent/nucleus-dynamic-css';
import PropTypes from 'prop-types';
export default class GroupRegistrationDialogContent extends ThemeableComponent {
    getStyleObject() {
        return {
            modalLabelStyles: this.getElementInlineStyle('attendeeSelectionModalStyles.modalLabelStyles'),
            modalLinkStyles: Object.assign(Object.assign({}, this.getElementInlineStyle('attendeeSelectionModalStyles.modalLinkStyles')), { display: 'inline-block' }),
            modalItemBackgroundStyles: this.getElementInlineStyle('attendeeSelectionModalStyles.modalItemBackgroundStyles'),
            modalAttendeeNameStyles: Object.assign(Object.assign({}, this.getElementInlineStyle('attendeeSelectionModalStyles.modalAttendeeNameStyles')), { display: 'inline-block' })
        };
    }
    render() {
        const { registrationCanAction, registrationCannotAction, translate, registrationAction, classes, instructionText, labelText, actionText } = this.props;
        const style = { style: this.getStyleObject() };
        return (React.createElement("div", null,
            React.createElement("div", Object.assign({}, resolve(style, 'modalLabelStyles')), instructionText),
            registrationCanAction &&
                registrationCanAction.map(registration => this.renderItem(registration.name, registration.id, registrationAction, style, classes, actionText, translate)),
            registrationCannotAction && registrationCannotAction.length > 0 && (React.createElement("div", null,
                React.createElement("div", Object.assign({}, resolve(style, 'modalLabelStyles')), labelText),
                registrationCannotAction.map(registration => {
                    return (React.createElement("div", { key: "noAction" },
                        React.createElement("span", { className: classes.attendeeSelectionName },
                            React.createElement("span", Object.assign({}, resolve(style, 'modalAttendeeNameStyles')), registration.name))));
                })))));
    }
    renderItem(name, registrationId, registrationAction, style, classes, actionText, translate) {
        return (React.createElement("div", null,
            React.createElement("div", Object.assign({}, resolve(style, 'modalItemBackgroundStyles')),
                React.createElement("span", { className: classes.attendeeSelectionName },
                    React.createElement("span", Object.assign({}, resolve(style, 'modalAttendeeNameStyles')), name)),
                React.createElement("span", { className: classes.attendeeSelectionLink },
                    React.createElement("a", Object.assign({}, resolve(style, 'modalLinkStyles'), { id: registrationId, href: "#", onClick: () => registrationAction(registrationId, translate) }), actionText))),
            React.createElement("div", { className: classes.attendeeSelectionSpace })));
    }
}
GroupRegistrationDialogContent.propTypes = {
    registrationAction: PropTypes.func.isRequired,
    registrations: PropTypes.object,
    classes: PropTypes.object.isRequired,
    style: PropTypes.object.isRequired,
    registrationCanAction: PropTypes.object.isRequired,
    registrationCannotAction: PropTypes.object.isRequired,
    instructionText: PropTypes.string.isRequired,
    labelText: PropTypes.string.isRequired,
    actionText: PropTypes.string.isRequired,
    translate: PropTypes.object
};
